"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestedRequest = void 0;
var InvestedRequest = /** @class */ (function () {
    function InvestedRequest() {
    }
    return InvestedRequest;
}());
exports.InvestedRequest = InvestedRequest;
;
//# sourceMappingURL=invested.request.js.map